import { Fragment } from "react";
import { Row } from "reactstrap";
import { Href } from "../../../../Constants/Constants";
import { useAppDispatch } from "../../../../ReduxToolkit/Hooks";
import { setMobileMenu } from "../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import CallNotification from "./CallNotification";
import UserCallProfile from "./UserCallProfile";

const CallContent = () => {
  const dispatch = useAppDispatch();
  return (
    <Fragment>
      <a className="icon-btn btn-outline-primary button-effect mobile-back mb-3" href={Href} onClick={() => dispatch(setMobileMenu())}>
        <i className="ti-angle-left" />
      </a>
      <Row>
        <UserCallProfile />
        <CallNotification />
      </Row>
    </Fragment>
  );
};

export default CallContent;
